import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";

export function getPrintLayerWfs(layer, olLayer) {

    let serviceUrl = layer.Url

    if(layer.Service.PrintDirectly === 1) {
        serviceUrl = layer.Service.PrintUrl
    } else {
        try {
            new URL(serviceUrl);
        } catch (_) {
            serviceUrl = window.kaartViewerUrl + serviceUrl
        }
    }

    let printLayer = {}
    if(serviceUrl.includes('/map?')) {
        printLayer.baseURL = serviceUrl + 'service=WFS&' +
            'version=1.1.0&typename=' + layer.Layer + '&' +
            'outputFormat=application/json&srsName=' + getViewProjectionName() + '&'
    } else {
        if(layer.Service.PrintDirectly === 1) {
            printLayer.baseURL = layer.Service.PrintUrl
        } else {
            printLayer.baseURL = layer.Url
        }
        printLayer.baseURL += '?service=WFS&version=1.1.0&request=GetFeature&typename=' + layer.Layer + '&outputFormat=application/json&srsName=EPSG:28992'
    }
    printLayer.type = 'WFS'
    printLayer.presentationID = layer.PresentationID
    printLayer.domainID = layer.DomainID
    printLayer.sorting = layer.zIndex
    printLayer.geometryType = olLayer.getSource().getFeatures()[0].getGeometry().getType()
    printLayer.opacity = layer.Opacity / 10

    const kvLayer = getKVLayerByBookmarkPresentationID(layer.ID)
    if(kvLayer.CQL_FILTER) {
        printLayer.baseURL += '&CQL_FILTER=' + kvLayer.CQL_FILTER
    }

    printLayer.baseURL = encodeURI(printLayer.baseURL)

    return printLayer
}
